import { Button } from "@freightsimple/ui-core/Controls/Button";
import { Units } from "@freightsimple/ui-core/Data/Units";

interface ConvertUnitsButtonProps {
  units: Units;
  setUnits: (_: Units) => void;
  dimensionsOnly?: boolean | undefined;
}

export function LineItemsConvertUnitsButton(props: ConvertUnitsButtonProps) {
  const text = props.dimensionsOnly
    ? props.units === Units.Imperial
      ? "Switch to cm"
      : "Switch to in"
    : props.units === Units.Imperial
      ? "Switch to cm/kg"
      : "Switch to in/lb";
  return (
    <Button
      size="link"
      onClick={function () {
        props.setUnits(
          props.units === Units.Imperial ? Units.Metric : Units.Imperial,
        );
      }}
    >
      {text}
    </Button>
  );
}
